export const StorybookPage = () => {
  return (
    <div className='h-screen w-full'>
      <iframe
        src='/storybook/index.html'
        className='size-full border-0'
        title='Storybook'
        sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-top-navigation'
      />
    </div>
  )
}
